import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";
import { Text } from "$components";

export enum BadgeStatuses {
  in_progress = "in_progress",
  canceled = "canceled",
  delivered_incomplete = "delivered_incomplete",
  done = "done",
  delivered_ok = "delivered_ok",
  new = "new",
  to_delivered = "to_delivered",
}

type BadgeProps = {
  disabled?: boolean;
  variant?: BadgeStatuses;
  messages: IBadgeStatus;
  clx?: string;
};

interface ObjectIndexer<T> {
  [id: string]: T;
}

export interface IBadgeStatus extends ObjectIndexer<string> {
  in_progress: string;
  canceled: string;
  delivered_incomplete: string;
  done: string;
  delivered_ok: string;
  new: string;
  to_delivered: string;
}

const STATUS_DEFAULT: IBadgeStatus = {
  in_progress: "En cours",
  canceled: "Annulé",
  delivered_incomplete: "Livré partiel",
  done: "Terminé",
  delivered_ok: "Livré total",
  new: "Nouveau",
  to_delivered: "En cours",
};

function JBadge({
  disabled = false,
  variant = BadgeStatuses.in_progress,
  messages = STATUS_DEFAULT,
  clx = "",
}: BadgeProps) {
  const classes = useStyles();
  const text: any = messages[variant] || messages.in_progress;
  let cls: string = disabled ? `${classes.disabled} ` : "";
  switch (variant) {
    case "in_progress":
      cls += `${classes.BadgeProgress} ${clx}`;
      break;
    case "canceled":
      cls += `${classes.BadgeCanceled} ${clx}`;
      break;
    case "new":
      cls += `${classes.BadgeCanceled} ${clx}`;
      break;
    case "delivered_incomplete":
      cls += `${classes.BadgeWarning} ${clx}`;
      break;
    case "done":
      cls += `${classes.BadgeDone} ${clx}`;
      break;
    case "delivered_ok":
      cls += `${classes.BadgeDone} ${clx}`;
      break;
    case "to_delivered":
      cls += `${classes.BadgeProgress} ${clx}`;
      break;
    default:
      cls += `${classes.BadgeProgress} ${clx}`;
  }
  return (
    <span
      style={{
        padding: "2px",
      }}
    >
      <Text
        className={cls}
        style={{ fontSize: 12, paddingLeft: 4, paddingRight: 4 }}
      >
        {text}
      </Text>
    </span>
  );
}

const useStyles = createUseStyles(() => ({
  base: {
    color: theme.color.white,
    padding: [0, 3],
    borderRadius: 4,
  },
  BadgeDone: {
    composes: "$base",
    background: theme.color.green,
  },
  BadgeProgress: {
    composes: "$base",
    background: theme.color.blueLight,
  },
  BadgeDanger: {
    composes: "$base",
    background: theme.color.red,
  },
  BadgeCanceled: {
    composes: "$base",
    background: theme.color.gray3,
  },
  BadgeWarning: {
    composes: "$base",
    background: theme.color.orange,
  },
  disabled: {
    background: theme.color.gray3,
  },
}));

export default JBadge;
